import type { ComponentProps, ReactNode } from 'react';
import { ContextMenu as Base } from '@base-ui/react/context-menu';
import { CANVAS_UI } from '../features/editor/canvas-ui';
import { cn } from './cn';
import { Menu, menuPopupClass } from './Menu';

/** Context menu popup at the pointer, in a portal, marked as canvas UI like `Menu` (P16-2). */
function Popup({
  label,
  children,
  className,
  finalFocus,
}: {
  label?: string;
  children: ReactNode;
  className?: string;
  finalFocus?: ComponentProps<typeof Base.Popup>['finalFocus'];
}) {
  return (
    <Base.Portal>
      <Base.Positioner className="z-50" {...{ [CANVAS_UI]: '' }}>
        <Base.Popup aria-label={label} finalFocus={finalFocus} className={cn(menuPopupClass, className)}>
          {children}
        </Base.Popup>
      </Base.Positioner>
    </Base.Portal>
  );
}

export const ContextMenu = { Root: Base.Root, Trigger: Base.Trigger, Popup, Item: Menu.Item, Separator: Menu.Separator };
